import { LoadBankAccountsRequestAction, LoadBankAccountsSuccessAction, LoadBankAccountsErrorAction } from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload } from './types.d';

const actions = {
  loadBankAccountsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadBankAccountsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_BANK_ACCOUNTS_REQUEST,
    payload,
  }),

  loadBankAccountsSuccess: (payload: ILoadDataSuccessPayload): LoadBankAccountsSuccessAction => ({
    type: actionsTypes.LOAD_BANK_ACCOUNTS_SUCCESS,
    payload,
  }),

  loadBankAccountsError: (): LoadBankAccountsErrorAction => ({
    type: actionsTypes.LOAD_BANK_ACCOUNTS_ERROR,
  }),
};

export default actions;
